import { unifiedAppParser } from 'api/parsers/unifiedAppParser';
import { fetch } from 'api/typedFetch';

export const getData = async () => {
  const response = await fetch('GET_TRADE_SHOWS');
  const data = await response.json();

  if (data.app !== undefined) {
    const [shows] = data.app;

    return shows.map((show) => {
      return unifiedAppParser(show);
    });
  }

  throw new Error('No show data found');
};
